<template>   
    <modal v-model="show"
           max-width="450"
           :has-padding="false"
           @input="emitInput">         

        <div>
            <div class="card-body">
                <h4 class="text-muted text-center">
                    {{bind.nome}}
                </h4>
                <h4 class="text-muted text-center">
                    Limite de acessos/leads
                </h4>
                <app-select v-model="tipoLimiteAcesso"
                            data-title="Selecione"
                            :data-search="false"
                            :data-items="limiterTypes"
                            :clearable="false"/>

                <v-text-field label="Quantidade"
                              v-if="tipoLimiteAcesso"
                              mask="########"
                              v-model="limiteAcesso"></v-text-field>
            </div>
            <div class="card-footer">
                <button class="btn btn-primary btn-round" @click="save()">
                    Salvar
                </button>
            </div>
        </div>
    </modal>     
</template>
<script>
    import AppSelect from '@components/Select'
    import EventBus from '@packages/event-bus'
    import Modal from "@/components/generic/Modal";

    export default {
        components: {
            AppSelect,
            Modal
        },

        data() {
            return {
                show: false,
                bind: {},
                tipoLimiteAcesso : '',
                dataAdvertiserId: null,
                limiteAcesso: null,
                limiterTypes:  [
                    {id: '', label: 'Sem limite'},
                    {id: 'LEAD', label: 'Lead'},
                    {id: 'ACESSO', label: 'Acesso'},
                ],
            }
        },

        methods:{
            emitInput(value) {
                this.$emit("input", value);
            },
            async save(){
                if (this.tipoLimiteAcesso && !this.limiteAcesso){
                    EventBus.$emit('show-message', {
                        type: 'ERROR',
                        message: 'Informe a quantidade limite.'
                    })

                    return;
                }else if (!this.tipoLimiteAcesso){
                    this.limiteAcesso = null
                    this.tipoLimiteAcesso = null
                }
                await this.$api.advertisersestablishment.updateAdvertisersEstablishment({
                    advertiserId: this.dataAdvertiserId,
                    establishmentId: this.bind.id,
                    data :{
                        limiteAcesso : this.limiteAcesso,
                        tipoLimiteAcesso : this.tipoLimiteAcesso
                    }
                })


                EventBus.$emit('show-message', {
                    type: 'SUCCESS',
                    message: 'Configurações salvas',
                    timeout: 2000
                })
                EventBus.$emit('ESTABLISHMENT_BOUND_LOAD')
            },
            editBindOptionsHandler(dataAdvertiserId, bind) {
                this.show = true
                this.bind = bind
                this.dataAdvertiserId = dataAdvertiserId
                this.tipoLimiteAcesso = bind.tipoLimiteAcesso
                this.limiteAcesso = bind.limiteAcesso
                console.log(this.bind)
            }

        },

        mounted() {
            EventBus.$on('EDIT_BIND_OPTIONS', this.editBindOptionsHandler)
        },

        beforeDestroy() {
            EventBus.$off('EDIT_BIND_OPTIONS', this.editBindOptionsHandler)
        }
    }
</script>

<style lang="scss" scoped>
    .card-body {

        text-align: center;
        padding: 18px 50px 10px;
        min-height: 130px !important;

        .v-input {
            margin: 12px 0 10px 0;
        }
    }
    .card-footer {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-bottom: 15px;

        .btn {
            margin: 15px;
        }
    }

</style>
